export enum ELocalizationLang {
  EN = "en",
  IT = "it",
}
